import { deleteWorkLog, DeleteWorkLogRequest } from "../../../services/workLog";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOGS } from "../queries/useQueryWorkLogs";
import { QUERY_WORK_LOGS_SUMMARY } from "../queries/useQueryWorkLogsSummary";

export const useMutationDeleteWorkLog = () =>
  useWSMutation<
    Awaited<ReturnType<typeof deleteWorkLog>>,
    WSServiceError,
    DeleteWorkLogRequest
  >(request => deleteWorkLog(request), {
    dependencies: [QUERY_WORK_LOGS, QUERY_WORK_LOGS_SUMMARY]
  });
